import { Route, Routes } from 'react-router-dom';
import { AppProviders } from '@/providers/AppProviders';
import { AppRoutes } from '@/routes';
import { AuthGate } from '@/auth/AuthGate';
import { SetPasswordPage } from '@/features/provisioning/pages/SetPasswordPage';
import { LoginPage } from '@/features/auth/pages/LoginPage';

/**
 * Top-level routing dispatcher.
 *
 * Public routes (anonymous, no auth required) are matched FIRST and
 * rendered without the AuthGate wrapper:
 *
 *   /imposta-password   — first-login set-password page reached from
 *                          the provisioning email link (PR-LP1/LP2).
 *   /login              — sign-in page (PR-LP3). Authenticated users
 *                          hitting this URL are redirected to "/" by
 *                          the page's local Firebase observer.
 *
 * Anything else delegates to `<AppRoutes />` wrapped in `<AuthGate>` —
 * the operational surface, which still requires an authenticated
 * Firebase session. AuthGate now redirects unauthenticated users to
 * `/login`, which closes the loop: anonymous → /login → sign in →
 * AuthGate authenticated → ApprovalGate → operational area.
 */
export function App(): JSX.Element {
  return (
    <AppProviders>
      <Routes>
        <Route path="/imposta-password" element={<SetPasswordPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="*"
          element={
            <AuthGate>
              <AppRoutes />
            </AuthGate>
          }
        />
      </Routes>
    </AppProviders>
  );
}
